import { StatLogger } from "OK/StatLogger";
import { Params } from "OK/metrics/Service";

export const logDataInternally = (logPrefix: string, serviceName: string, param1: string, param2?: string): void => {
    const prefix = `${logPrefix}.${serviceName}`;

    // Without modifying logs in GwtOperationLogger there are only 2 params
    StatLogger.success(prefix, param1, param2!);
}

export const debugLog = (serviceName: string, ...args: unknown[]): void => {
    window.OK.logging.info(`[${serviceName}]`, ...args);
};

export const transformParam = (paramKey: string, paramValue: unknown): string => {
    switch (paramValue) {
        case true:
        case "true": {
            paramValue = 'YES';
            break;
        }
        case undefined:
        case null:
        case false:
        case "false": {
            paramValue = 'NO';
            break;
        }
    }
    return `${paramKey}_${paramValue}`;
};

export const transformParamsForDebugLog = (params?: Params): string => {
    const result: string[] = [];

    for (const paramKey in params) {
        result.push(transformParam(paramKey, params[paramKey]));
    }

    return result.join('&');
};
